export function showElement(element: HTMLElement) {
  element.style.display = 'flex';
}

export function hideElement(element: HTMLElement) {
  element.style.display = 'none';
}

async function waitForDocumentBody() {
  if (document.body) return;
  await new Promise<void>((res) =>
    window.addEventListener('DOMContentLoaded', () => res()),
  );
}

export async function addToDocumentBody(element: HTMLElement) {
  await waitForDocumentBody();
  document.body.appendChild(element);
}
